import RingLoader from "../../Loaders/RingLoader";

const ScanDevicesButton = ({ loading, startScan, stopScan }) => {
    return (
        <button
            type="button"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full active:bg-blue-700 items-center w-full"
            onClick={loading ? () => stopScan() : () => startScan()}
        >
            <div className="flex flex-row gap-1 items-center justify-center">
                {loading ? (
                    <>
                        <RingLoader size={20}/>
                        <div>Stop scan</div>
                    </>
                ) : (
                    <div>Scan devices</div>
                )}
            </div>
        </button>
    );
};

export default ScanDevicesButton;
